export default __webpack_public_path__ + "f2cfa9c41fa1a2e8b7ca8082a8bfb467.png";